import { useMemo } from "react";

import useAccountChildren from "../../../../hooks/useAccountChildren";
import useCompetition from "../../../../hooks/useCompetition";
import useLocalStorage from "../../../../hooks/useLocalStorage";
import { ApiCategory, ApiProfile } from "../../../../types";

type PreparedCompetitor = {
  userUUID: string;
  categoryUUID: string;
  competitorNumber?: string;
};

export default function usePreparedCompetitors(competitionUUID?: string) {
  const { competition } = useCompetition(competitionUUID);
  const [preparedCompetitors, setPreparedCompetitors] = useLocalStorage<
    PreparedCompetitor[]
  >(competitionUUID ? `${competitionUUID}/preparedCompetitors` : null, []);
  const { children } = useAccountChildren();

  const competitors = useMemo(
    () =>
      preparedCompetitors
        .map(({ userUUID, categoryUUID }) => ({
          userUUID,
          categoryUUID,
          profile: children?.find((x) => x.uuid === userUUID),
          category: competition?.stages[0]?.categories.find(
            (x) => x.uuid === categoryUUID
          ),
        }))
        .filter((x) => !!x.profile && !!x.category) as (PreparedCompetitor & {
        profile: ApiProfile;
        category: ApiCategory;
      })[],
    [competition, children, preparedCompetitors]
  );
  const setCompetitors = (newCompetitors: PreparedCompetitor[]) => {
    setPreparedCompetitors(
      newCompetitors.map((x) => ({
        userUUID: x.userUUID,
        categoryUUID: x.categoryUUID,
      }))
    );
  };
  return [competitors, setCompetitors] as const;
}
